import layout from '@/layout'
const meta = { auth: true }

export default {
  path: '/sample',
  component: layout,
  children: ((pre) => [
    {
      path: 'sampleCategorySet',
      name: `${pre}sampleCategorySet`,
      meta: {
        ...meta,
        cache: true,
        title: '样品分类维护',
        head: true,
        funcID: 'B0301',
        PID: 'B00',
      },
      component: () => import('@/views/backstage/sample/sampleCategorySet'),
    },
    {
      path: 'sampleMetadata',
      name: `${pre}sampleMetadata`,
      meta: {
        ...meta,
        cache: true,
        title: '样品属性维护',
        head: true,
        funcID: 'B0302',
        PID: 'B00',
      },
      component: () => import('@/views/backstage/sample/sampleMetadata'),
    },
    {
      path: 'sampleInputTemplate',
      name: `${pre}sampleInputTemplate`,
      meta: {
        ...meta,
        cache: true,
        title: '属性录入模板',
        head: true,
        funcID: 'B0303',
        PID: 'B00',
      },
      component: () => import('@/views/backstage/sample/sampleInputTemplate'),
    },
    {
      path: 'sampleInformation',
      name: `${pre}sampleInformation`,
      meta: {
        ...meta,
        cache: true,
        title: '样品资料维护',
        head: true,
        funcID: 'B0304',
        PID: 'B00',
      },
      component: () => import('@/views/backstage/sample/sampleInformation'),
    },
    {
      path: 'sampleInformation/:pageType/:sampleCode?',
      name: `${pre}sampleInformation-detail`,
      meta: {
        ...meta,
        cache: true,
        title: ({ $route }) => {
          const { sampleStyleNo = '' } = $route.query || {}
          return sampleStyleNo || '样品资料维护'
        },
        head: false,
        funcID: 'B0304',
        PID: 'B00',
        pageConfig: { layout: { class: 'bg-transparent p-0' } },
      },
      component: () =>
        import('@/views/backstage/sample/sampleInformation/detail'),
    },
    {
      path: 'proofing',
      name: `${pre}proofing`,
      meta: {
        ...meta,
        cache: true,
        title: '样品依赖书维护',
        head: true,
        funcID: 'B0306',
        PID: 'B00',
      },
      component: () => import('@/views/backstage/sample/proofing'),
    },
    {
      path: 'proofing/:pageType/:proofingCode?',
      name: `${pre}proofing-detail`,
      meta: {
        ...meta,
        cache: true,
        title: '样品依赖书维护',
        head: false,
        funcID: 'B0306',
        PID: 'B00',
      },
      component: () => import('@/views/backstage/sample/proofing/detail'),
    },
    {
      path: 'sampleFormula',
      name: `${pre}sampleFormula`,
      meta: {
        ...meta,
        cache: true,
        title: '核价公式维护',
        head: true,
        funcID: 'B0305',
        PID: 'B00',
      },
      component: () => import('@/views/backstage/sample/sampleFormula'),
    },
    {
      path: 'sampleFormula/:pageType/:formulaCode?',
      name: `${pre}sampleFormula-detail`,
      meta: {
        ...meta,
        cache: true,
        title: '核价公式维护',
        head: false,
        funcID: 'B0305',
        PID: 'B00',
      },
      component: () => import('@/views/backstage/sample/sampleFormula/detail'),
    },
    {
      path: 'setproofing',
      name: `${pre}setproofing`,
      meta: {
        ...meta,
        cache: true,
        head: true,
        funcID: 'B0307',
        PID: 'B00',
      },
      component: () => import('@/views/backstage/sample/setproofing'),
    },
    {
      path: 'setproofing/:pageType/:sampleSetCode?',
      name: `${pre}setproofing-detail`,
      meta: {
        ...meta,
        cache: true,
        title: ({ $route }) => {
          const { sampleSetNo = '' } = $route.query || {}
          return `样品套件维护 | ${sampleSetNo || 'New'}`
        },
        head: false,
        funcID: 'B0307',
        PID: 'B00',
        pageConfig: { layout: { class: 'bg-transparent p-0' } },
      },
      component: () => import('@/views/backstage/sample/setproofing/detail'),
    },
    {
      path: 'prebuiltSampleNo',
      name: `${pre}prebuiltSampleNo`,
      meta: {
        ...meta,
        cache: true,
        head: true,
        funcID: 'B0308',
        PID: 'B00',
      },
      component: () => import('@/views/backstage/sample/prebuiltSampleNo'),
    },
  ])('sample-'),
}
